// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page.BC-Page__GlobalSelling .card-subs {
  margin-top: 20px;
  padding: 20px;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container {
  display: flex;
  justify-content: space-between;
  gap: 6rem;
  align-items: center;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container:nth-child(even) {
  margin-top: 12px;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container.global-e-integration {
  padding: 12px;
  border-radius: 8px;
  background-color: #F6F6F7;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item__label {
  font-weight: 500;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item__content {
  color: #6d7175;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-action {
  min-width: 40px;
  max-width: max-content;
  margin: auto 0;
}

.global-e-icon {
  border-radius: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global-selling.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".BC-Page.BC-Page__GlobalSelling .card-subs {\n  margin-top: 20px;\n  padding: 20px;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container {\n  display: flex;\n  justify-content: space-between;\n  gap: 6rem;\n  align-items: center;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container:nth-child(even) {\n  margin-top: 12px;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container.global-e-integration {\n  padding: 12px;\n  border-radius: 8px;\n  background-color: #F6F6F7;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item__label {\n  font-weight: 500;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item__content {\n  color: #6d7175;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-action {\n  min-width: 40px;\n  max-width: max-content;\n  margin: auto 0;\n}\n\n.global-e-icon {\n  border-radius: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
